import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ToastMessageType, ToastService } from '../../../../../../Common/toast';
import { Step } from '../../../Models';
import { ModuleService } from '../../../Services/module.service';
import { TranslationService } from '../../../Services/translation.service';
import { AvailabilityService } from './availability.service';
import { AvailabilityConditionComponent } from './availability-condition.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'aw-availability-container',
    templateUrl: './availability-container.component.html',
    styleUrls: ['./availability-container.component.less'],
    imports: [AvailabilityConditionComponent, MatIconButton, MatIcon, MatButton]
})
export class AvailabilityContainerComponent implements OnInit {
    selectedStepId: string = "";
    stepName: string;
    versionNumber: number;
        
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private moduleService: ModuleService,
        private translationService: TranslationService,
        public availabilityService: AvailabilityService,
        private toast: ToastService
    ) { }

    ngOnInit(): void {
        let selectedStep: Step = this.moduleService.selectedStep;
        
        if (selectedStep.StepName) {
            this.translationService
                .getTranslation(selectedStep.StepName, 'Text')
                .subscribe(name => this.stepName = name);
        }

        this.route.queryParams.pipe(filter(params => params.stepId))
            .subscribe(params => {
                this.selectedStepId = params.stepId;
            });

        const urlTree: UrlTree = this.router.parseUrl(this.router.url);
        this.versionNumber = parseInt(urlTree.root.children.primary.segments[5].path);

        this.availabilityService.canSave = false;
        this.availabilityService.getConditionFields(this.selectedStepId);
        this.availabilityService.setExistingConditions(selectedStep.FieldBasedAvailability);       
    }
    
    onNewItemClick(): void {
        this.availabilityService.addCondition();
    }

    onSaveClick(): void {
        if (this.availabilityService.validateConditions()) {
            this.availabilityService.saveConditions(this.versionNumber);
            this.moduleService.selectedStep.FieldBasedAvailability = this.availabilityService.conditions;
        } else {
            this.toast.sendMessage(
                "Unable to save",
                "All conditions must have a Field, an Identifer and a Value",
                ToastMessageType.error);
        }
    }
}
